
const apiUrlBase: string = "http://localhost:4583";

export const environment = {
  apiUrl: `${apiUrlBase}/api`,
  USUAPP: 'dev-client',
  HOST_NAME: 'web-client'
};
